import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { SERIES_QUERY_KEY, addShowsToSeries } from "./api";

interface AddShowsToSeriesParams {
  seriesId: string;
  showIds: string[];
  venuePageId: string;
}

/**
 * Hook to batch-assign a set of existing shows to a series in a single
 * atomic update. Invalidates the series list on success; callers should also
 * invalidate any show-list query keys they want refreshed.
 */
export function useAddShowsToSeries(): UseMutationResult<
  void,
  Error,
  AddShowsToSeriesParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ seriesId, showIds }: AddShowsToSeriesParams) =>
      addShowsToSeries(seriesId, showIds),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SERIES_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
